import {mq} from './../../js/helpers/mq';
import {debounce} from './../../js/helpers/listeners';

let currentScreenTarget = '(min-width: 1140px)',
    lastScrollTop = 0;

const updateHeaderOnScroll = function() {
    const isDesktop = mq.lg.matches;

    if(!isDesktop){
        return false;
    }

    const scrollY = window.pageYOffset || document.documentElement.scrollTop,
        header = document.querySelector('.header');

    if (scrollY > 50 && scrollY > lastScrollTop) { //NB: 50 is the value calculated by anchor-scroll.js
        header.classList.add('is-scrolled');
        moveSearchInHeaderWrapper();
    } else {
        header.classList.remove('is-scrolled');
        moveSearchInUtilityNav();
    }

    lastScrollTop = scrollY <= 0 ? 0 : scrollY;
};

const moveSearchInUtilityNav = function(){
    const searchEl = document.querySelector('.dropdown__container--search'),
        utilityNavWrapper = document.querySelector('.utility-nav__wrapper');

    utilityNavWrapper.appendChild(searchEl);
}

const moveSearchInHeaderWrapper = function(){
    const searchEl = document.querySelector('.dropdown__container--search'),
        headerWrapper = document.querySelector('.header-wrapper');

    headerWrapper.appendChild(searchEl);
}

const renderLayoutAsPerDevice = function(e){
    const isDesktop = mq.lg.matches,
        isMobile = mq.mobile.matches;

    if(isDesktop){
        moveSearchInUtilityNav();
        mq.lg.addListener( reloadHeaderOnScreenResize);
    }else{
        const headerWrapper = document.querySelector('.header-wrapper'),
            utilityNavItems = document.querySelectorAll('.utility-nav li'),
            primaryNav = headerWrapper.querySelector('.primary-nav'),
            primaryNavMenu = primaryNav.querySelector('.primary-menu'),
            headerBtn = headerWrapper.querySelector('.header-btn a');

        for(let i=0, l=utilityNavItems.length; i < l; i++){
            utilityNavItems[i].classList.add('utility-item');

            primaryNavMenu.appendChild(utilityNavItems[i]);
        }

        if(isMobile) {
            const newItem = document.createElement("LI");

            newItem.classList.add('header-btn');
            newItem.appendChild(headerBtn);
    
            primaryNavMenu.insertBefore(newItem, primaryNavMenu.childNodes[0]);

            mq.mobile.addListener( reloadHeaderOnScreenResize);
        }else {
            const newItem = document.createElement("div");

            newItem.classList.add('header-btn');
            newItem.appendChild(headerBtn);
            headerWrapper.insertBefore(newItem, headerWrapper.childNodes[2]);

            mq.tablet.addListener( reloadHeaderOnScreenResize);
        }
    }
}

//quick fix - TODO: avoid page reload, rearrange DOM instead
const reloadHeaderOnScreenResize = function(e) {
    location.reload();
}

//Init Header
renderLayoutAsPerDevice();

//Remove top padding on mobile
if($('.gs-mobile-top-medium').length){
    if($('section.hero')){
        $('section.hero').addClass("hero__slide-up");
    }
  }
document.addEventListener('scroll', debounce(updateHeaderOnScroll), { passive: true });